"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = arrayMax;
/**
 * Return the highest value (number) in the given array
 *
 * @param {Array} array The array to be scanned
 * @returns {Array} The highest value
 *
 * @throws {TypeError} When the passed array is not actually an array.
 *
 * @example
 * const sourceArray = [1,3,2];
 * arrayMax(sourceArray); // Returns: 3
 *
 * @example
 * arrayClean() // throws: Cannot read property 'length' of undefined
 */
function arrayMax(array, comparisonFn) {
    var i = 0,
        ln = array.length,
        item,
        max = array[0];

    for (; i < ln; i++) {
        item = array[i];

        if (comparisonFn) {
            if (comparisonFn(max, item) === -1) {
                max = item;
            }
        } else {
            if (item > max) {
                max = item;
            }
        }
    }

    return max;
}
//# sourceMappingURL=arrayMax.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-utilizr/lib/arrayMax.js
 ** module id = 311
 ** module chunks = 0
 **/